import Layout from '@/page/index/'

export default [
//   {
//   path: '/wel',
//   component: Layout,
//   redirect: '/wel/index',
//   children: [{
//     path: 'index',
//     name: '首页',
//     meta: {
//       i18n: 'dashboard'
//     },
//     component: () =>
//       import( /* webpackChunkName: "views" */ '@/views/wel/index')
//   }, {
//     path: 'dashboard',
//     name: '控制台',
//     meta: {
//       i18n: 'dashboard',
//       menu: false,
//     },
//     component: () =>
//       import( /* webpackChunkName: "views" */ '@/views/wel/dashboard')
//   }]
// },
  
  {
   path: '/overView',
    component: Layout,
    redirect: 'overView/omCenter',
    children: [{
      path: 'omCenter',
      name: '地图总览',
      meta: {
        i18n: 'dashboard'
      },
      component: () =>
        import( /* webpackChunkName: "views" */ '@/views/overView/omCenter')
    }]
},
{
  path: '/overView',
   component: Layout,
 
   children: [{
     path: 'alarmPush',
     name: '地图总览',
     meta: {
       i18n: 'dashboard'
     },
     component: () =>
       import( /* webpackChunkName: "views" */ '@/views/overView/alarmPush')
   }]
},
  {
    path: '/overView/globalPage',
    component: () =>
    import( /* webpackChunkName: "views" */ '@/views/overView/globalPage')
  },
  {
  path: '/test',
  component: Layout,
  redirect: '/test/index',
  children: [{
    path: 'index',
    name: '测试页',
    meta: {
      i18n: 'test'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/desk/notice')
  }]
}, {
  path: '/dict-horizontal',
  component: Layout,
  redirect: '/dict-horizontal/index',
  children: [{
    path: 'index',
    name: '字典管理',
    meta: {
      i18n: 'dict',
      keepAlive:true
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-horizontal')
  }]
}, {
  path: '/dict-vertical',
  component: Layout,
  redirect: '/dict-vertical/index',
  children: [{
    path: 'index',
    name: '字典管理',
    meta: {
      i18n: 'dict'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/util/demo/dict-vertical')
  }]
}, {
  path: '/info',
  component: Layout,
  redirect: '/info/index',
  children: [{
    path: 'index',
    name: '个人信息',
    meta: {
      i18n: 'info'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/system/userinfo')
  }]
}, {
  path: '/work/process/leave',
  component: Layout,
  redirect: '/work/process/leave/form',
  children: [{
    path: 'form/:processDefinitionId',
    name: '请假流程',
    meta: {
      i18n: 'work'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/work/process/leave/form')
  }, {
    path: 'handle/:taskId/:processInstanceId/:businessId',
    name: '处理请假流程',
    meta: {
      i18n: 'work'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/work/process/leave/handle')
  }, {
    path: 'detail/:processInstanceId/:businessId',
    name: '请假流程详情',
    meta: {
      i18n: 'work'
    },
    component: () =>
      import( /* webpackChunkName: "views" */ '@/views/work/process/leave/detail')
    },
  //   {
  //   path: '/historicalData',
  //   component: () => import('@/views/deviceMonitor/historicalData/index.vue'),
  //   meta: {
  //     title: '历史数据'
  //   }
  // }, {
  //   path: '/dataHistoryAnalysis',
  //   component: () => import('@/views/deviceMonitor/dataAnalysis/index.vue'),
  //   meta: {
  //     title: '数据统计'
  //   }
  // }, {
  //   path: '/deviceOverview',
  //   component: () => import('@/views/deviceMonitor/deviceOverview/index.vue'),
  //   meta: {
  //     title: '设备概况'
  //   }
  // }, {
  //   path: '/deviceLive',
  //   component: () => import('@/views/deviceMonitor/deviceLive/index.vue'),
  //   meta: {
  //     title: '设备实况'
  //   }
  //   }
  ]
}]
